module.exports = __webpack_public_path__ + "static/media/survive-l.3a72d77e.png";